module.exports = __webpack_public_path__ + "img/title05.b94dbc09.png";